import './Footer.css';
function Footer() {
  return (
    <footer className="footer">
      <div className="footer__logo">
        <div className="footer__logo-icon">💧</div>
        <span className="footer__brand">Akış Tesisat</span>
      </div>
      <p className="footer__copy">© 2024 Akış Tesisat — Tüm Hakları Saklıdır</p>
      <div className="footer__right">
        <a href="tel:+905469314601" className="footer__phone">0546 931 46 01</a>
      </div>
    </footer>
  );
}
export default Footer;
